{
	"cancelSetupMessage": "Are you sure you want to cancel the project setup?",
	"cancelSetupPrimary": "Continue Setup",
	"cancelSetupSecondary": "Cancel Setup",
	"cancelSetupTitle": "Cancel Project Setup",
	"closingProject": "Closing project...",
	"creatingProject": "Creating project...",
	"deleteProjectError": "Something went wrong while deleting project {{name}}. Please try again.",
	"deleteProjectSuccess": "Project {{name}} has been deleted",
	"errorClosingProject": "Error closing project. Some changes may not be saved.",
	"errorDeleteNoCatalogPermission": "We are unable to clean up your catalog and style files because we do not have permission to access the project folder.",
	"errorDeleteNoFolder": "We are unable to clean up your catalog and style files because the project folder is missing.",
	"errorDeleteProjectLocked": "We are unable to delete your project because it is currently active in another browser window or tab.",
	"errorLoadAiStyle": "Failed to load AI Style. Please try again.",
	"loadingAiStyle": "Loading AI Style...",
	"loadingProject": "Loading project...",
	"noCompatibleFiles": "No compatible RAW files found in selected folder",
	"preparingPhotos": "Preparing your photos...",
	"projectInUseMessage": "Resetting will overwrite the catalog and will impact the usage by the other account. This action cannot be undone. Are you sure you want to reset and overwrite?",
	"projectInUsePrimary": "Reset and Overwrite",
	"projectInUseTitle": "Project in use by another account",
	"restoreHiddenMessage_one": "{{count}} photo was previously hidden. Would you like to restore it?",
	"restoreHiddenMessage_other": "{{count}} photos were previously hidden. Would you like to restore them?",
	"restoreHiddenPrimary": "Restore",
	"restoreHiddenTitle": "Restore hidden photos",
	"savingProject": "Saving changes to your project...",
	"switchingToCulling": "Switching to culling..."
}
